// /PurchaseReturnRecord/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import PurchaseReturnRecordFilters from "./components/PurchaseReturnRecordFilters";
import PurchaseReturnRecordTable from "./components/PurchaseReturnRecordTable"; // ✅ use correct table
import { fetchPurchaseReturnRecord } from "./PurchaseReturnRecordThunk";
import ReportDom from "../../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { exportPurchaseReturnRecordCsv } from "./components/exportPurchaseReturnRecordCsv";

const { Title } = Typography;

const PurchaseReturnRecord = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  // 👇 pull data safely (avoid destructuring undefined)
  const purchaseReturnRecordState = useSelector((state) => state.purchaseReturnRecord) || {};
  const { filters = {}, list = [] } = purchaseReturnRecordState;
  const navigate = useNavigate();
  const authInfo  = useSelector((state) => state.auth?.auth_info);
  useEffect(() => {
    dispatch(fetchPurchaseReturnRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Purchase Return Report",
    removeAfterPrint: true,
  });

  const handleNavigateToReports = () => {
    navigate(-1);
  };
  const handleDownloadCsv = () => {
    exportPurchaseReturnRecordCsv({
      list,
      filters,
      authInfo,
      title:    "Purchase Return Record",
      filename: "purchase_return_record",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
          <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />  
          <Title level={4} style={{ margin: 0 }}>Purchase Return Record</Title>
          </div>
        }
         extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <PurchaseReturnRecordFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <PurchaseReturnRecordTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Purchase Return Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <PurchaseReturnRecordTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default PurchaseReturnRecord;
